// extracted by mini-css-extract-plugin
export default {"toolbar":"FaxesToolbar_toolbar_zJEeo"};